export const url = "https://emeraldcapitalhq.com/emerald/api";


// export const url = "http://localhost:5000/emerald/api";





